const REDUX_ACTION = {
  DELETE: 'REDUX_DELETE',
  DELETE_LOCALLY: 'REDUX_DELETE_LOCALLY',
  DELETE_ERROR: 'REDUX_DELETE_ERROR',
  DELETE_SUCCESS: 'REDUX_DELETE_SUCCESS',
  LOAD: 'REDUX_LOAD',
  LOAD_ERROR: 'REDUX_LOAD_ERROR',
  LOAD_SUCCESS: 'REDUX_LOAD_SUCCESS',
  RESET: 'REDUX_RESET',
  SAVE: 'REDUX_SAVE',
  SAVE_ERROR: 'REDUX_SAVE_ERROR',
  SAVE_SUCCESS: 'REDUX_SUCCESS',
  SET: 'REDUX_SET',
  UPDATE: 'REDUX_UPDATE',
  UPDATE_VIEWED_AT: 'REDUX_UPDATE_VIEWED_AT',
  VALIDATE: 'REDUX_VALIDATE'
}

const REDUX_ACTION_PREFIX = Object.keys(REDUX_ACTION)
  .reduce((obj, key) => {
    obj[key] = REDUX_ACTION[key].replace('REDUX_', '')
    return obj
  }, {})

export { REDUX_ACTION_PREFIX }

export default REDUX_ACTION
